import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withIsMobile from '@hooks/withDetectSizeHOC';
import { Page, MobileContainer, DesktopContainer } from '@containers/layout';
import { Heading, Box, Button } from '@components/common';
import SegmentedControl from '@components/SegmentedControl';
import { MyCleansList, CalendarView } from '@containers/cleans';
import history from '@utils/history';
import CleansActions, { CleansSelectors } from '@redux/CleansRedux';
import redirect from '@services/redirect';
import AuthedSpruceModal from '@containers/account/AuthedSpruceModal';
import SpruceBookingModal from '@containers/booking/SpruceBookingModal';

let seenSupportModal = false;

const VIEW_SEMENTS = {
  CLEANS: 'Services',
  CALENDAR: 'Calendar'
};

const MainDesktop = styled(DesktopContainer)`
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    justify-content: space-between;
  }
`;

const ContainerView = styled(MobileContainer)`
  align-self: flex-start;
  align-items: stretch;

  @media screen and (min-width: 768px) and (max-width: 1023px) {
    margin-left: 10px;
    margin-right: 10px;
  }

  @media screen and (min-width: 1024px) {
    padding-top: 0px;
  }
`;

class HomePage extends React.Component {
  static propTypes = {
    loadMyCleansOfMonth: PropTypes.func,
    loadMyCleansList: PropTypes.func,
    loading: PropTypes.bool,
    isMobile: PropTypes.number,
    setActiveView: PropTypes.func,
    activeView: PropTypes.string
  };

  state = {
    showBookingModal: false
  };

  componentDidMount() {
    const { loadMyCleansOfMonth, loadMyCleansList } = this.props;
    if (redirect.get() && redirect.valid()) {
      history.push(redirect.formFullPath());
      redirect.set(null);
    }

    loadMyCleansOfMonth();
    loadMyCleansList();
  }

  handleCleanItemClick = item => {
    const { bookingID: bookingId } = item;
    history.push(`/bookings/${bookingId}`);
  };

  renderMobileLayout() {
    const { activeView } = this.props;
    return (
      <MobileContainer>
        <Box
          width={1}
          flex={1}
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          py={4}
        >
          {activeView === VIEW_SEMENTS.CLEANS && (
            <MyCleansList mb={4} onItemClick={this.handleCleanItemClick} />
          )}
          {activeView === VIEW_SEMENTS.CALENDAR && (
            <CalendarView onItemClick={this.handleCleanItemClick} />
          )}
        </Box>
        <Button
          width={1}
          mt={2}
          mb={4}
          type="button"
          onClick={() => {
            this.setState({ showBookingModal: true });
          }}
        >
          Schedule New Service
        </Button>
      </MobileContainer>
    );
  }

  renderDesktopLayout() {
    return (
      <MainDesktop>
        <CalendarView flex={1} onItemClick={this.handleCleanItemClick} />
        <ContainerView>
          <Heading mt={0} px={2} mb={4}>
            My Services
          </Heading>
          <MyCleansList mb={4} onItemClick={this.handleCleanItemClick} />
          <Button
            width={1}
            mt={2}
            mb={4}
            type="button"
            onClick={() => {
              this.setState({ showBookingModal: true });
            }}
          >
            Schedule New Service
          </Button>
        </ContainerView>
      </MainDesktop>
    );
  }

  renderSegment = () => {
    const { setActiveView, activeView } = this.props;
    return (
      <SegmentedControl
        segments={[VIEW_SEMENTS.CLEANS, VIEW_SEMENTS.CALENDAR]}
        size="big"
        value={activeView}
        onChange={view => {
          setActiveView(view);
        }}
      />
    );
  };

  render() {
    const { isMobile } = this.props;

    // TODO: need to show loading

    return (
      <Page renderHeaderAccessory={() => this.renderSegment()}>
        {isMobile ? this.renderMobileLayout() : this.renderDesktopLayout()}
        <AuthedSpruceModal
          link="https://spruce.page.link/PfBF"
          show={!seenSupportModal}
          dismiss={() => {
            seenSupportModal = true;
            this.forceUpdate();
          }}
        />

        <SpruceBookingModal
          link="https://spruce.page.link/cLyn"
          show={this.state.showBookingModal}
          dismiss={() => {
            this.setState({ showBookingModal: false });
          }}
        />
      </Page>
    );
  }
}

const mapStatesToProps = state => ({
  loading: CleansSelectors.selectLoading(state),
  activeView: CleansSelectors.selectHomeView(state)
});

const mapDispatchToProps = dispatch => ({
  loadMyCleansOfMonth: () =>
    dispatch(CleansActions.setMyCleansOfMonthLoadRequest()),
  loadMyCleansList: () => dispatch(CleansActions.setMyCleansLoadRequest()),
  setActiveView: view => dispatch(CleansActions.setMyCleansHomeView(view))
});

const connected = connect(
  mapStatesToProps,
  mapDispatchToProps
)(HomePage);

export default withIsMobile(connected);
